import { valoracionService } from "@/_services";

export const valoracion = {
  namespaced: true,
  state: {
    entity: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getValoracionRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getValoracionSuccess(state, env) {
      state.entity.data = env;
      state.entity.status = {
        loaded: true,
      };
    },
    getValoracionError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
  },
  actions: {
    getValoracion({ commit }, envioId) {
      commit("getValoracionRequest");
      valoracionService
        .getValoracion(envioId)
        .then((env) => {
          commit("getValoracionSuccess", env);
        })
        .catch((error) => {
          commit("getValoracionError", error);
        });
    },
  },
};
